<template>
    <v-container>
        <h3>Patient List</h3>
        <!-- <DataTable
            :columns="header"
            :rows="patients"
        ></DataTable> -->
        <table id="patientlist" v-show="false">
            <tr>
                <th>Name</th>
                <th>Insurance</th>
                <th>Email</th>
                <th>Remarks</th>
                <th>PIC</th>
            </tr>
            <tr v-for="patient in patients" :key="patient['key']">
                <td>{{ patient.name }}</td>
                <td>{{ patient.department }}</td>
                <td>{{ patient.status }}</td>
                <td>{{ patient.date }}</td>
            </tr>
        </table>
        <v-text-field label="Search" v-model="searchPatient" outline></v-text-field>
        <v-data-table
            :items="patients"
            :headers="header"
            :search="searchPatient"
        >
            <template v-slot:items="patient">
                <td>{{ patient.item.name }}</td>
                <td>{{ patient.item.department }}</td>
                <td>{{ patient.item.status }}</td>
                <td>{{ patient.item.date }}</td>
                <td>
                    <v-btn v-for="button in patient.item.action" @click="buttonAction(button.action)" :to="button.href" :key="button['id']" :color="button.color" small depressed>
                        {{ button.text }}
                    </v-btn>
                </td>
            </template>   
        </v-data-table>
        <v-btn fab depressed color="danger" @click="shareLink = true" fixed bottom>
            <v-icon>
                mdi-share-variant
            </v-icon>
        </v-btn>
        <v-btn color="success" @click="exportToCSV(csvData)">Export To CSV</v-btn>
        <v-btn dark @click="exportToPDF()">Export To PDF</v-btn>

        <Modal
            :dialog="shareLink" @close="shareLink = false"
        >
        
            <div slot="header">
                <p>Link has been generated</p>
            </div>
           
            <div slot="body">
                 <vue-qrcode :value="host+'/#/assessment/'+company_id" /> 
                <p>Copy the link below and share</p>
                <v-text-field readonly outline :value="host+'/#/assessment/'+company_id" id="link"></v-text-field>
                <p class="body-2" v-show="isCopied" style="position:absolute; bottom: 200px;">Copied to clipboard</p>
            </div>
            <div slot="footer">
                 
                <social-sharing :url="host+'/#/assessment/'+company_id" inline-template>
                    <div >
                        <network network="facebook" style="position:absolute; bottom: 60px;">
                            <v-btn color="blue"><fa-icon :icon="['fab','facebook']"></fa-icon></v-btn>
                        </network>
                        <network network="email" style="position:absolute; bottom: 60px; left: 120px;">
                            <v-btn color="danger"><fa-icon icon="mail-bulk"></fa-icon></v-btn>
                        </network>
                        <network network="twitter" style="position:absolute; bottom: 60px; left: 220px;">
                            <v-btn color="blue"><fa-icon :icon="['fab','twitter']"></fa-icon></v-btn>
                        </network>
                        <network network="whatsapp" style="position:absolute; bottom: 60px; left: 320px;">
                            <v-btn color="success"><fa-icon :icon="['fab','whatsapp']"></fa-icon></v-btn>
                        </network>
                         
                    </div>
                </social-sharing>
                <v-btn color="black" @click="copyToClipboard()">Copy To Clipboard</v-btn>
                <v-btn @click="shareLink = false" v-show="!isCopied" color="red">Close</v-btn>
            
            </div>
        </Modal>
        <Modal
            :dialog="openAnatomy"
            @close="openAnatomy = false"
            fullscreen
            hide-overlay
        >
            <div slot="header">
                <p>Form 2</p>
                   
            </div>
            <div slot="body"> 
                <Assess @submitted="openAnatomy = false" :form_id="form_id"></Assess>
                <v-btn @click="openAnatomy = false"  color="red">Cancel</v-btn>
            </div>
        </Modal>
    </v-container>
</template>
<script>
import Form2 from '@/views/Form2';
import db from '@/components/firebase.init';
import moment from 'moment';
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import VueQrcode from 'vue-qrcode'


export default {
    data(){
        return{
            header:[
                {
                    text: 'Name',
                    value: 'name',
                    type: 'text'
                },
                {
                    text: 'Department',
                    value: 'department',
                    type: 'text'
                },
                {
                    text: 'Status',
                    value: 'status',
                    type: 'text'
                },
                {
                    text: 'Date Submitted',
                    value: 'date',
                    type: 'text'
                },
                {
                    text: 'Action',
                    value: 'action',
                    type: 'button'
                },
            ],
            shareLinks:[
                {
                    network: 'facebook',
                    prefix: 'fab',
                    icon: 'facebook'
                },
                {
                    network: 'email',
                    prefix: 'fas',
                    icon: 'mail-bulk'
                },
                {
                    network: 'twitter',
                    prefix: 'fab',
                    icon: 'twitter'
                },
            ],
            patients:[],
            company_id: this.$route.params.companyId,
            form_id: '',
            searchPatient: '',
            isCopied: false,
            host: window.location.host,
            shareLink: false,
            openAnatomy: false
        }
    },
    methods:{
        currentDate(){
            return moment().format('Do MMMM YYYY');
        },
        getPatient(){
            this.patients = [];
            db.collection('forms').where('company_id','==',this.company_id)
            .onSnapshot(doc =>{
                this.patients = [];
                doc.forEach(item =>{
                    let doc = item.data();
                    doc.id = item.id;
                    doc.action = [];
                    console.log(doc);
                       if(doc.status == null){
                     doc.action.push(
                        {
                            text: 'Assess',
                            color: 'secondary',
                            action:{
                                method: 'viewAnatomy',
                                params: doc.id
                            }
                        }
                    )

                    }
                    if(doc.status != null){
                          doc.action.push(
                       {
                            text: 'View',
                            color: 'secondary',
                            action:{
                                method: 'viewResults',
                                params: doc.id
                            }
                        }
                    )
                    }
                    doc.action.push(
                    
                        {
                            text: 'Delete',
                            color: 'danger',
                            action:{
                                method: 'deleteAssessment',
                                params: doc.id
                            }
                        },
                        
                        
                        
                    )
                    if(!doc.deleted_at){
                        this.patients.push(doc);
                    }
                })
            })
        },
        viewAnatomy(id){
            this.openAnatomy = true;
            this.form_id = id;
        },
        deleteAssessment(id){
            console.log(id);
            if(confirm('Are you sure you want to delete this assessment? This action cannot be undone!')){
                db.collection('forms').doc(id).update(
                    {
                        deleted_at: this.currentDate()
                    }
                )
            }
        },
        buttonAction(action){
            this[action.method](action.params);
        },
        copyToClipboard(){
            let link = document.querySelector('#link');
            link.select();
            document.execCommand('copy');
            this.isCopied = true;
            setTimeout(()=> {
                this.isCopied = false;
            },3000)
        },
        exportToCSV(data){
            let csvContent = "data:text/csv;charset=utf-8,";
            csvContent +=[
                Object.keys(data[0]).join(";"),
                ...data.map(item => Object.values(item).join(";"))
            ]
            .join("\n")
            .replace(/(^\[)|(\]$)/gm, "")
            console.log(data);
            const doc = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", doc);
            link.setAttribute("download", "patientlist.csv");
            document.body.appendChild(link)
            link.click();
            document.body.removeChild(link)
        },
        exportToPDF(){
            var doc = new jsPDF({orientation: 'landscape'});
            let columns = [];
            let rows = [];
            this.patients.map(item => {
                rows.push(
                    [
                        item.name,
                        item.department,
                        item.status,
                        item.date
                    ]
                )
            })
            doc.autoTable(
                {
                    head: [['Name', 'Department', 'Status', 'Date Submitted']],
                    body: rows
                }
            );
            doc.save("patientlist.pdf")
        },
        viewResults(id){
              this.$router.push('/companyId/'+this.company_id+'/formsId/'+id);
        },
    },
    computed:{
        csvData(){
            return this.patients.map(item =>({
                ...item,
                name: item.name,
                department: item.department,
                status: item.status,
                date_submitted: item.date_submitted
            }))
        }
    },
    components:{
        'Assess' : Form2,VueQrcode
    },
    beforeMount(){
        this.getPatient();
    }
}
</script>

